module.exports = __webpack_public_path__ + "static/media/stretcher_icon.7d4c9cb0.svg";